<ng-container>
  <modal-header [title]="'Invalid'" (onClose)="onClose()" [closeable]="false"></modal-header>

  <div class="modal-body">
    <p>{{ message }}</p>
  </div>

  <modal-footer [footerStyle]="'single_btn'" (onSubmit)="onClose()" [saveLabel]="'Ok'"></modal-footer>
</ng-container>
